export default "__VITE_ASSET__Cva9CVsO__"